export default {
  bede: "Bede",
  menu: "Meny",
  menuAria: "Vis eller skjul menyen",
  homeLink: "Hjem",
  calendarLink: "Program",
  mapLink: "Kart",
  about: "om",
  aboutLink: "Om oss",
  importCalendar: "Mobilkalender",
  importCalendarLink: "Mobilkalender",
  activities: "Aktiviteter",
  activitiesLink: "Aktiviteter",
  membership: "Medlemskap",
  membershipLink: "Medlemskap",
  donations: "Givertjeneste",
  donationsLink: "Givertjeneste",
  event: "Arrangement",
  intro: "Hva skjer?",
  coordinator: "Koordinator",
  organizer: "Arrangør",
  moreEvents: "Se videre program",
  shareMessage:
    "En lenke til dette arrangementet er kopiert til utklippstavlen.",
  print: "🖨",
  expandAll: "Fyldig",
  collapseAll: "Sammendrag",
  attendingDefinite: "Kommer",
  attendingMaybe: "Kanskje",
};
